import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a84d942c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "execirse-content"
};
import { watch, reactive } from 'vue';
import Execrise from '@/components/Execirse';
export default {
  __name: 'ExecirsePop',
  props: {
    dialogExecrise: {
      type: Boolean,
      default: false
    },
    questionList: {
      type: Array,
      default: () => []
    }
  },
  emits: ['closeExeDialog'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const state = reactive({
      dialogExecrise: false,
      canAnswer: true
    });
    watch(() => props.dialogExecrise, val => {
      state.dialogExecrise = val;
    });
    const closeExeDialog = () => {
      emit('closeExeDialog');
    };
    return (_ctx, _cache) => {
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
        class: "pop",
        title: "试题预览",
        modelValue: state.dialogExecrise,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => state.dialogExecrise = $event),
        width: "1200px",
        onClose: closeExeDialog
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_unref(Execrise), {
          canAnswer: state.canAnswer,
          questionList: props.questionList
        }, null, 8, ["canAnswer", "questionList"])])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};